import { goJoinEvent } from "@/lobby_common/utils/utils.js";
export default {
  components: {},
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cur_left: 0,
      max_left: 0,
      num: 7,
    };
  },
  watch: {},
  async created() {},
  mounted() {
    // console.log("this.item.list.length", this.item.list.length);
    this.item.list.shift();
    this.item.list = this.item.list.filter((v) => {
      return v.isShow === 1;
    });
    if (this.item.list.length % this.num > 0) {
      // 不能整除
      this.max_left = Math.floor(this.item.list.length / this.num) * 100;
    } else {
      // 能整除
      this.max_left = (Math.floor(this.item.list.length / this.num) - 1) * 100;
    }
  },
  computed: {
    lang() {
      return this.$store.getters.getLang;
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    titleList() {
      return this.item.labels[0] || {};
    },
    lists() {
      const list =
        this.item.labels && this.item.labels.length
          ? this.item.labels.map((it, i) => {
            console.log(it, this.curindex, i, "it");
            return { ...it, eid: `101_16_${this.curindex}_${i}` };
          })
          : [];
      list.shift();
      if (!this.IsMobile) {
        let newArr = [...list];
        if (list.length > this.num) {
          const count = list.length % this.num;
          if (count !== 0) {
            const arr1 = list.slice(0, -count);
            const arr2 = list.slice(-this.num);
            newArr = [...arr1, ...arr2];
          }
        }
        return newArr;
      }
      return list;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config
        ?.titleAlignment;
    },
  },
  methods: {
    handelClick(obj) {
      // console.log(obj, "obj");
      this.$eventPost("click", {
        eid: obj.eid,
        jump_value: obj.jump,
        time: Date.now(),
      });
      if (obj.jump?.type === "Jump_TYPE_MULTIPLE_GAME") {
        if (obj.jump.multipleGame?.sid) {
          const item = { ...obj, bindType: 3 };
          console.log(item, "Cur_paramsCur_paramsCur_params");
          localStorage.setItem("Cur_params", JSON.stringify(item));
          this.$router.push({ name: "homeSearch" });
        }
      } else {
        // 除了多款游戏其他跳转
        goJoinEvent(obj.jump);
      }
    },
    changePosition(dir = "left") {
      const that = this;
      const dom = document.querySelector(`.content_${this.curindex}`);
      if (dom) {
        const target =
          dir === "left" ? that.cur_left - 100 : that.cur_left + 100;
        this.animateDom(target, dom, dir);
      }
    },
    animateDom(target, dom, dir) {
      const that = this;
      if (that.timer) {
        return false;
      }
      // let timer = that.timer;
      that.timer = setInterval(function () {
        const speed = dir === "left" ? -5 : 5; // 判断是向左走（负）还是向右走（正）
        // console.log(dir, that.cur_left, target);
        if (that.cur_left === target) {
          clearInterval(that.timer);
          that.timer = null;
        } else {
          that.cur_left = that.cur_left + speed;
          if (that.cur_left === 0) dom.style.left = 0;
          else dom.style.left = `-${that.cur_left}%`;
        }
      }, 10);
    },
  },
};
